var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{attrs:{"href":"javascript:"},on:{"click":_vm.createSampleData}},[_vm._v("create sample data")])])}
var staticRenderFns = []

export { render, staticRenderFns }